import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccountService } from '@qaroni-app/account/services/account.service';
import { Account, UserDTO } from '@qaroni-app/account/types/account';
import { ProfileViewEnum } from '@qaroni-app/account/types/profile-view.enum';
import { ImagesConfig } from '@qaroni-core/conf/images/images.config';
import { InputErrorMessageComponent } from '@qaroni-shared/components/input-error-message/input-error-message.component';
import { LoadButtonDirective } from '@qaroni-shared/directives/load-button.directive';
import { AccountAvatarComponent } from '../account-avatar/account-avatar.component';
import { AccountEditForm } from './account-edit.form';

@Component({
  selector: 'qaroni-account-edit',
  standalone: true,
  imports: [
    AccountAvatarComponent,
    FormsModule,
    InputErrorMessageComponent,
    LoadButtonDirective,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './account-edit.component.html',
  styleUrl: './account-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountEditComponent extends AccountEditForm implements OnChanges {
  @Input() account: Account | null = null;
  @Output() changeView = new EventEmitter<ProfileViewEnum>();

  public ImagesConfig = ImagesConfig;

  private accountService = inject(AccountService);

  ngOnChanges(): void {
    if (this.account) {
      this.name.setValue(this.account.name);
    }
  }

  public changeViewInfo(): void {
    this.changeView.emit(ProfileViewEnum.INFO);
  }

  public onSubmit(): void {
    if (!this.validatedForm) {
      return;
    }

    this.enableLoading();
    const userDTO: UserDTO = {
      imageToken: this.image.valid ? this.image.value : null,
      name: this.name.value,
    };

    this.accountService.accountUpdate(userDTO);
  }
}
